module.exports = __webpack_public_path__ + "static/media/eddy-travia-200x200.fbacf349.jpg";